"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AsyncTaskResponse () {
        return AsyncTaskResponse;
    },
    get AsyncTaskStatusUpdateEvent () {
        return AsyncTaskStatusUpdateEvent;
    },
    get GetAsyncTasksByNameResponse () {
        return GetAsyncTasksByNameResponse;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const AsyncTaskStatusUpdateEvent = _zod.z.object({
    _id: _zod.z.string(),
    name: _zod.z.string(),
    companyId: _zod.z.string(),
    userId: _zod.z.string().nullable(),
    status: _models.AsyncTaskStatusEnum,
    createdAt: _zod.z.string(),
    startedAt: _zod.z.string().nullable(),
    completedAt: _zod.z.string().nullable(),
    progressCount: _zod.z.number(),
    progressTotal: _zod.z.number(),
    metadata: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional(),
    error: _zod.z.string().optional()
});
const AsyncTaskResponse = _models.AsyncTaskModel.omit({
    error: true
}).extend({
    error: _zod.z.string().nullable().optional().transform((val)=>val ?? undefined)
});
const GetAsyncTasksByNameResponse = _zod.z.array(AsyncTaskResponse);
